"use strict";

// Copyright 2022 Fewcha. All rights reserved.
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toDecimal = exports.toHuman = void 0;
const toHuman = function (input, decimal) {
  let fractionDigit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 3;
  let delimiter = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : ",";
  if (input.length < decimal) {
    if (input.length + fractionDigit < decimal) {
      return "0";
    } else {
      return "0".concat(delimiter).concat(input.slice(0, Math.min(fractionDigit, decimal)));
    }
  } else {
    const fractionPositon = input.length - decimal;
    const decimalNumber = "".concat(input.slice(fractionPositon, Math.min(fractionDigit, decimal)));
    if (decimalNumber !== "") {
      return "".concat(input.slice(0, fractionPositon)).concat(delimiter).concat(decimalNumber);
    } else {
      return "".concat(input.slice(0, fractionPositon));
    }
  }
};
exports.toHuman = toHuman;
const toDecimal = function (input, decimal) {
  let delimiter = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ".";
  var splitInput = input.split(delimiter);
  if (splitInput.length !== 2) {
    throw new Error("Invalid number");
  }
  // integral
  const integral = splitInput[0] === "0" ? "" : splitInput[0];
  // decimal
  const _decimal = splitInput[1].length <= decimal ? "".concat(splitInput[1]).concat("0".repeat(decimal - splitInput[1].length)) : "".concat(splitInput[1].slice(0, decimal));
  return integral + _decimal;
};
exports.toDecimal = toDecimal;